import PublicHolidayListResourceModel from '../../generated/types/model/resource/PublicHolidayListResourceModel';

export default class PublicHolidayListResourceViewModel extends PublicHolidayListResourceModel {
  // For instructions on how to use ViewModels visit: 
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
